export default __webpack_public_path__ + "static/media/notarias.eec7b302.svg";